import { Pipe, PipeTransform, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { DynamicTranslationService } from '@gs-2.0/core';

@Pipe({
  name: 'translate',
  standalone: true,
  pure: false
})
export class TranslatePipe implements PipeTransform, OnDestroy {
  private lastKey: string = '';
  private lastValue: string = '';
  private subscription?: Subscription;

  constructor(
    private translationService: DynamicTranslationService,
    private cdr: ChangeDetectorRef
  ) {}

  transform(key: string, params?: { [key: string]: any }): string {
    if (!key || key === '') {
      return key;
    }

    // If key hasn't changed, return cached value
    if (key === this.lastKey && !params) {
      return this.lastValue;
    }

    // Clean up previous subscription
    if (this.subscription) {
      this.subscription.unsubscribe();
    }

    // Subscribe to translation changes
    this.subscription = this.translationService.translate(key, params).subscribe(
      translation => {
        this.lastKey = key;
        this.lastValue = translation;
        this.cdr.markForCheck();
      }
    );

    // Return instant translation or key
    return this.translationService.instant(key, params);
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}